import FilterBar from 'components/common/FilterBar';
import { ISingleFilterOptionProps } from 'components/common/FilterBar/types';
import { usStatesSelectOptions } from 'constants/usStates';
import React from 'react';

import { FilterContainerStyled } from './styled';

const ByStateFilterBar: React.FC = () => {
  const options: ISingleFilterOptionProps[] = usStatesSelectOptions;
  return (
    <FilterContainerStyled style={{ width: 'auto', minWidth: 300 }}>
      <FilterBar
        notSpecifiedValueLabel=''
        options={options}
        name='state'
        inputSettings={{ mode: 'multiple' }}
        placeholder='Select state...'
      />
    </FilterContainerStyled>
  );
};

export default React.memo(ByStateFilterBar);
